var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefreshIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_3)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_3",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0H0V20H20V0Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 18.3333C8.95833 18.3333 7.98264 18.1354 7.07291 17.7396C6.1632 17.3438 5.37153 16.809 4.69791 16.1354C4.02431 15.4618 3.48958 14.6702 3.09375 13.7604C2.69791 12.8507 2.5 11.875 2.5 10.8333H4.16667C4.16667 12.4583 4.73264 13.8368 5.86458 14.9688C6.99653 16.1007 8.375 16.6667 10 16.6667C11.625 16.6667 13.0035 16.1007 14.1354 14.9688C15.2674 13.8368 15.8333 12.4583 15.8333 10.8333C15.8333 9.20834 15.2674 7.82986 14.1354 6.69792C13.0035 5.56597 11.625 5.00001 10 5.00001H9.875L11.1667 6.29168L10 7.50001L6.66667 4.16668L10 0.833344L11.1667 2.04168L9.875 3.33334H10C11.0417 3.33334 12.0174 3.53126 12.9271 3.9271C13.8368 4.32292 14.6285 4.85765 15.3021 5.53126C15.9757 6.20486 16.5104 6.99654 16.9063 7.90626C17.3021 8.81597 17.5 9.79168 17.5 10.8333C17.5 11.875 17.3021 12.8507 16.9063 13.7604C16.5104 14.6702 15.9757 15.4618 15.3021 16.1354C14.6285 16.809 13.8368 17.3438 12.9271 17.7396C12.0174 18.1354 11.0417 18.3333 10 18.3333Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
export default __webpack_public_path__ + "static/media/refreshIcon.3db37783cc722f1bbeabfc544edec3e5.svg";
export { ForwardRef as ReactComponent };